export default __webpack_public_path__ + "static/media/blank.bb5bab7d.png";